/**
 * @GENERATED from Figma node 3608:51030
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const TwitterDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${_id})`}>
        <path
          fill="#fff"
          d="M13.64 11.464 20.923 3h-1.725l-6.323 7.35L7.824 3H2l7.636 11.114L2 22.99h1.726l6.677-7.761 5.333 7.76h5.824zm-2.363 2.747-.773-1.106-6.157-8.806h2.65l4.969 7.107.774 1.106 6.458 9.238h-2.65z"
        />
      </g>
      <defs>
        <clipPath id={_id}>
          <path fill="#fff" d="M2 3h19.56v20H2z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(TwitterDark);
export { ForwardRef as TwitterDark };
